import { render, staticRenderFns } from "./DesktopPlanTable.vue?vue&type=template&id=ffcb80c4"
import script from "./DesktopPlanTable.vue?vue&type=script&lang=js"
export * from "./DesktopPlanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports